import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { ReconcileRoutePage } from "../app/reconcileRoute";

export const Route = createFileRoute("/reconcile")({
  component: ReconcileRoute,
});

function ReconcileRoute(): JSX.Element {
  const search = Route.useSearch();
  return <ReconcileRoutePage search={search} />;
}
